import React, { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import Card from "../ui/Card/Card";
import styles from "./PurchaseDetailsCard.module.sass";
import OfferType from "../OfferType/OfferType";
import KeyValueItem from "../ui/KeyValueItem/KeyValueItem";
import currency from "../../utils/currency";
import AppContext from "../../contexts/appContext";
import mediaQuery from "../../utils/mediaQuery";
import OfferDetails from "../../components/OfferDetails/OfferDetails";

const purchaseDetailsCard = (props) => {
  const { selectedOffer } = props.offer;
  const [showModal, setShowModal] = useState(false);
  const { setContext, ...context } = useContext(AppContext);

  const [desktop, setDesktop] = useState(
    mediaQuery.watchIfDesktop((e) => setDesktop(e.matches))
  );

  useEffect(() => mediaQuery.unsubscribe, []);

  const showModalHandler = () => {
    setContext({ ...context, showModal: true });
    setShowModal(true);
  };

  const hideModalHandler = () => {
    setContext({
      ...context,
      modalOpen: false,
      error: {
        show: false,
        internalError: null,
      },
    });
    setShowModal(false);
  };

  return (
    <>
      <div className={styles.OfferCard}>
        <Card showHeader={true} className={styles.cardForm}>
          <div className={styles.cardHeader}>
            <OfferType
              className={styles.offerTypeForm}
              showIcon={true}
              type={props.offer.product.id}
              groupLabel="Grupo"
              groupNumber={selectedOffer.identificacao.codigoNegocio}
            />
          </div>
          <KeyValueItem
            className={styles.cardItem}
            noDivider
            Key={"Valor do crédito "}
            Value={
              "R$ " +
              currency.numberToCurrency(
                props.offer.selectedOffer.dados.valorCredito
              )
            }
          />
          <KeyValueItem
            className={styles.cardItem}
            noDivider
            Key={"Parcelas a partir de "}
            Value={
              "R$ " +
              currency.numberToCurrency(
                props.offer.selectedOffer.dados.valorParcela
              )
            }
          />
          <KeyValueItem
            className={styles.cardItem}
            noDivider
            Key={"Durante "}
            Value={
              props.offer.selectedOffer.dados.plano.prazo.restante + " Meses"
            }
          />
          <KeyValueItem
            className={styles.cardItem}
            noDivider
            Key={
              <p className={styles.detailsLink} onClick={showModalHandler}>
                Ver detalhes
              </p>
            }
          />
        </Card>
      </div>
      <Modal
        centered
        dialogClassName={styles.modalDialog}
        className={styles.OfferDetails}
        show={showModal}
        onHide={hideModalHandler}
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <OfferDetails
            isDesktop={desktop}
            offer={{ group: context.selectedOffer }}
            productType={context.product.id}
            internalError={context.error.internalError}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default purchaseDetailsCard;
